module.exports = __webpack_public_path__ + "static/media/mall-value.a50b40e6.png";